import styled from 'styled-components';
import {BasicAnalysisResult} from '@/map/@types';
import {getSidoName} from '@/map/utils';
import {Box, BoxGroup} from '../StyledComponents';
import {TotalAvgItem} from './TotalAvgItem';

interface IProps {
  data?: BasicAnalysisResult;
  isPending?: boolean;
}

export const PresumePolulation = ({data, isPending}: IProps) => {
  const ctprvn = getSidoName(data?.average?.sido);

  return (
    <BoxGroup>
      <Block>
        <TotalAvgItem
          title="거주"
          loading={isPending}
          total={data?.population}
          sidoAvg={data?.average?.population}
          sidoName={ctprvn}
        />
      </Block>
      <Block>
        <TotalAvgItem
          title="직장"
          loading={isPending}
          total={data?.officeWorker}
          sidoAvg={data?.average?.officeWorker}
          sidoName={ctprvn}
        />
      </Block>
    </BoxGroup>
  );
};

const Block = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 4px;
`;
